"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactSpring = require("react-spring");

var _constants = require("./constants");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AnimatedWrapper = function AnimatedWrapper(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      isAboveTrigger = _ref.isAboveTrigger,
      onOpened = _ref.onOpened,
      onClosed = _ref.onClosed;

  var _useMemo = (0, _react.useMemo)(function () {
    var slideStartPosition = isAboveTrigger ? _constants.ANIMATION_SLIDE_AMOUNT : 0 - _constants.ANIMATION_SLIDE_AMOUNT;
    return {
      closedStyles: {
        opacity: 0,
        transform: "translateY(".concat(slideStartPosition, "px)")
      },
      openStyles: {
        opacity: 1,
        transform: "translateY(0px)"
      }
    };
  }, [isAboveTrigger]),
      openStyles = _useMemo.openStyles,
      closedStyles = _useMemo.closedStyles;

  var transitions = (0, _reactSpring.useTransition)(isOpen, {
    from: closedStyles,
    enter: _objectSpread(_objectSpread({}, openStyles), {}, {
      onRest: function onRest() {
        return isOpen && onOpened && onOpened();
      }
    }),
    leave: _objectSpread(_objectSpread({}, closedStyles), {}, {
      onRest: function onRest() {
        return !isOpen && onClosed && onClosed();
      }
    }),
    config: {
      duration: _constants.ANIMATION_DURATION
    }
  });
  return transitions(function (props, item) {
    return item && (0, _core.jsx)(_reactSpring.animated.div, {
      style: props
    }, children);
  });
};

AnimatedWrapper.displayName = 'AnimatedWrapper';
var _default = AnimatedWrapper;
exports.default = _default;